import type { Car } from '@ahd/shared/types/ahd-cars/car/car';
import axios from './Axios';
import { getAxiosHeader, urlServicesRelease } from './AxiosVars';

export type AIPreisschild = {
    carId?: Car['id'];
    id: number;
    ident?: Car['nr'];
    name?: string;
    status?: string;
    statusId: 0 | 1 | 2 | 3;
    vin?: Car['ch'];
};

export function getPreisschilder(signal: AbortController['signal']) {
    return axios<{ data: AIPreisschild[] }>({
        title: 'Abrufen der Preisschilder',
        method: 'get',
        url: `${urlServicesRelease}/cars/v1/ai/list`,
        headers: getAxiosHeader(),
        signal: signal,
    });
}

export function setPreisschilder(idCar: number, idPreisschild: number) {
    return axios<{ code: number; status: 'success' | 'error'; message: string; data: null }>({
        title: 'Verbinden des Preisschilds',
        method: 'post',
        url: `${urlServicesRelease}/firma3/v1/ai/set/${idCar}/${idPreisschild}`,
        headers: getAxiosHeader(),
    });
}

export function releasePreisschilder(idPreisschild: number) {
    return axios<{ code: number; status: 'success' | 'error'; message: string; data: null }>({
        title: 'Loslösen des Preisschilds',
        method: 'post',
        url: `${urlServicesRelease}/firma3/v1/ai/release/${idPreisschild}`,
        headers: getAxiosHeader(),
    });
}
